import CompanyTaxesDisplay from './CompanyTaxesDisplay';

const RestaurantTaxesDisplay = ({ restaurantId, hideTitle = false }) => (
  <CompanyTaxesDisplay restaurantId={restaurantId} hideTitle={hideTitle} />
);

export default RestaurantTaxesDisplay;
